import { render, staticRenderFns } from "./ManageService.vue?vue&type=template&id=a083f4bc&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ManageService.vue?vue&type=style&index=0&id=a083f4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a083f4bc",
  null
  
)

export default component.exports